import { call, put } from 'redux-saga/effects';

import { getDepartamentoProduto } from '../../components/departamentoDetalhe/api';

import { Creators as produtosActions } from '../ducks/produtos';

// O * identifica um generator assim como async, e o yield é um await
function* searchProdutos(action) {
    const { payload } = action,
        { idDepartamento, params } = payload;
    const list = yield call(getDepartamentoProduto, idDepartamento, params);

    const {
        data: { data }
    } = list;

    const { itens } = data;

    const parsedItens = itens.map((item) => {
        if (item.lsProdutoImagem && item.lsProdutoImagem.length) {
            item.lsProdutoImagem = JSON.parse(item.lsProdutoImagem);
        }
        return item;
    });

    list.data.data.itens = parsedItens;

    yield put(produtosActions.searchProdutos({ list }));
}

export { searchProdutos };
